import styled from 'styled-components';
import { rgba } from 'polished';
import { theme } from '../../styles/config/theme';
import { typeStyle } from '../../styles/config/typeStyles';
import { StyledWrapper } from '../common/Wrapper/Wrapper.styles';
import media from '../../styles/config/mediaQueries';

const StyledContainer = styled.header`
  position: fixed;
  top: 0;
  width: 100%;
  background-color: ${props => (props.isWhite ? props.theme.color.white : props.theme.color.black)};
  color: ${props => (props.isWhite ? props.theme.color.black : props.theme.color.white)};
  border-bottom: 1px solid ${rgba(theme.color.white, 0.1)};
  z-index: 10;
  ${media.mobile`
    min-height: 64px;
    padding: 21px 0 13px;
  `}
  ${media.desktop`
    min-height: unset;
    padding: 9px 0 8px;
  `}

  ${StyledWrapper} {
    display: flex;
    align-items: center;
    ${media.mobile`
      justify-content: space-between;
    `}
    ${media.desktop`
      max-width: 1162px;
      padding: 0 26px;
    `}
  }

  .home {
    display: block;
    height: 25px;
  }
`;

const StyledMenu = styled.nav`
  display: flex;
  align-items: center;
  background-color: ${props => props.theme.color.black};
  ${media.mobile`
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 5px 56px 6px;
    width: 100%;
    min-height: 64px;
    border-top: 1px solid ${rgba(theme.color.white, 0.1)};
  `}
  ${media.desktop`
    width: 250px;
    margin-left: auto;
  `}
`;

const StyledList = styled.ul`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0;
`;

const StyledItem = styled.li`
  list-style: none;
  ${media.desktop`
    &:hover {
      button {
        opacity: 1;
      }
    }
  `}

  .active button {
    opacity: 1;
  }
`;

const StyledButton = styled.button`
  width: 29px;
  height: 29px;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0.65;
`;

const StyledUserButton = styled.button`
  width: 18px;
  height: 18px;

  svg {
    width: 100%;

    path {
      fill: ${props => (props.isWhite ? props.theme.color.black : props.theme.color.white)};
    }
  }
`;

const StyledBackButton = styled.button`
  width: 18px;
  height: 18px;

  svg path {
    fill: ${props => (props.isWhite ? props.theme.color.black : props.theme.color.white)};
  }
`;

const StyledTitle = styled.h2`
  ${typeStyle.h2};
  text-transform: uppercase;
`;

export {
  StyledContainer,
  StyledMenu,
  StyledList,
  StyledItem,
  StyledButton,
  StyledUserButton,
  StyledBackButton,
  StyledTitle,
};
